module.exports = __webpack_public_path__ + "img/homePageImg09.58b7a408.png";